import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import DataTable from 'prefabsComponents/Tables/DataTable';
import useFetch from 'hooks/useFetch';
import DefaultCell from 'layouts/pages/orders/order-list/components/DefaultCell';
import DataTableLoader from 'components/DataTableLoader';
import DataTableHeaderOptions from 'components/DataTableHeaderOptions';
import DataTableDocumentActions from 'components/DataTableDocumentActions';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const Roles = () => {
    const { data, isLoading } = useFetch('/api/maintenance/roles/');
    const [dataTableData, setDataTableData] = useState({ columns: [], rows: [] });

    useEffect(() => {
        if(data){
            const renderCell = ({ value }) => <DefaultCell value={value} />;

            const columns = [
                { Header: 'Id', accessor: 'id_cargo', Cell: renderCell },
                { Header: 'Nombre', accessor: 'nombre_cargo', Cell: renderCell },
                { Header: 'Acciones', accessor: 'acciones', Cell: renderCell },
            ];

            const rows = data.map((provider) => ({
                id_cargo: provider.id_cargo,
                nombre_cargo: provider.nombre_cargo,
                acciones: (
                    <DataTableDocumentActions
                        actions={[{
                            Icon: EditIcon,
                            onClick: () => {},
                            color: 'primary'
                        }]}
                    />
                )
            }));

            setDataTableData({ columns, rows });
        }
    }, [data]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <DataTableHeaderOptions
                createNewTitle='Nuevo Rol'
                dataTableData={dataTableData}
                hasFilters={false}
                getData={() => {}}
                CreateNewModal={() => {}}
            />
            <Card>
                {isLoading ? (
                    <DataTableLoader />
                ) : (
                    <DataTable
                        table={dataTableData}
                        entriesPerPage={true}
                        canSearch={true}
                        showTotalEntries={true}
                    />  
                )}
            </Card>
            <Footer />
        </DashboardLayout>
    );
}

export default Roles;
